import { api, LightningElement } from "lwc";
export default class extends LightningElement {
  @api ctaHref: string | null = null;
  @api ctaTarget: string | null = null;
  @api ctaTitle: string | null = null;
  @api imgAlt: string | null = null;
  @api imgAspect: string | null = null;
  @api imgSrc: string | null = null;
  @api description: string | null = null;
  @api title: string = "";
  @api background: "white" | "dark" | "light" = "white";

  private get promoClassName() {
    return `promo promo--${this.background}`;
  }

  private onClick() {
    let { ctaHref, ctaTarget } = this;
    if (ctaHref) {
      if (ctaTarget) window.open(ctaHref, ctaTarget);
      else window.location.href = ctaHref;
    }
  }

  private onLinkClick(e: MouseEvent) {
    e.stopPropagation();
  }
}
